export const getLinkColor = (selected?: number) => (selected ? 'blue100' : 'grey090');
